import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/ReportCard/TermComments/components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'termComments',
    name: 'termComments',
    component: Index,
    title: 'termComments',
    redirect: { name: 'term-comments-list' },
    children: [
      {
        path: 'list',
        name: 'term-comments-list',
        component: List,
      },
      
    ],
  },
]
